import { useRouter } from '@uhg-abyss/web/hooks/useRouter';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import { Link } from '@uhg-abyss/web/ui/Link';
import { Text } from '@uhg-abyss/web/ui/Text';
import { t } from 'i18next';

export const BackButton = () => {
  const { navigate } = useRouter();
  const handleGoBack = () => {
    navigate(-1);
  };
  return (
    <Link
      css={{
        marginBottom: '12px',
      }}
      data-auto-testid="back-to-provider-details"
      data-testid="back-to-provider-details"
      href="#"
      isStandardAnchor
      onClick={handleGoBack}
    >
      <IconSymbol
        color="$core.color.brand.60"
        css={{ width: '24px', height: '24px', marginRight: '4px' }}
        icon="arrow_back"
        title="Back"
      />
      <Text color="$core.color.brand.60" fontWeight="bold">
        {t('BACK')}
      </Text>
    </Link>
  );
};
